<div class="row">
  <ng-container *ngFor="let article of news; let i = index">
    <div [ngClass]="{'col-12': true, 'col-md-6': i > 0 || !firstWide, 'col-lg-4': i > 0 || !firstWide}">
      <app-news-item [article]="article" [horizontal]="firstWide && i == 0" [showIntro]="firstWide && i == 0" [showTags]="showTags || (showTagsForFirst && i == 0)"></app-news-item>
    </div>
  </ng-container>
</div>
